import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { REMEDIATION, CONTACT } from "@/data/content";

export default function Remediation() {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 100]);

  return (
    <div>
      <section className="relative h-[85vh] min-h-[560px] overflow-hidden" data-testid="service-hero">
        <motion.img style={{ y }} src={REMEDIATION.hero} alt="Remediation" className="absolute inset-0 w-full h-[115%] object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/50" />
        <div className="relative h-full container-x flex flex-col justify-end pb-16 md:pb-24 text-white">
          <Overline light className="mb-6">Specialist Discipline · {REMEDIATION.index}</Overline>
          <h1 className="font-display text-6xl md:text-8xl lg:text-[8rem] font-extrabold leading-[0.85] tracking-tighter uppercase">{REMEDIATION.title}</h1>
          <p className="mt-6 text-[0.8rem] uppercase tracking-[0.25em] text-sand">{REMEDIATION.tagline}</p>
        </div>
      </section>

      <section className="container-x py-24 md:py-32 max-w-3xl">
        <Reveal>
          <p className="font-display text-2xl md:text-3xl font-bold leading-snug">{REMEDIATION.short}</p>
          <p className="mt-8 text-lg font-light text-taupe leading-relaxed">{REMEDIATION.intro}</p>
        </Reveal>
      </section>

      <section className="bg-offwhite py-24 md:py-32" data-testid="remediation-disciplines">
        <div className="container-x">
          <Overline className="mb-14">The Disciplines</Overline>
          <div className="grid md:grid-cols-3 gap-px bg-black/10">
            {REMEDIATION.disciplines.map((d, i) => (
              <Reveal key={d.name} delay={i * 0.1}>
                <div className="bg-offwhite h-full p-8 md:p-10">
                  <span className="font-mono text-sm text-sand">0{i + 1}</span>
                  <h3 className="font-display text-2xl font-bold mt-4 mb-2">{d.name}</h3>
                  <p className="text-[0.65rem] uppercase tracking-[0.2em] text-taupe mb-4">{d.tagline}</p>
                  <p className="text-taupe font-light leading-relaxed">{d.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="container-x py-24 md:py-32 grid grid-cols-2 md:grid-cols-3 gap-4">
        {REMEDIATION.gallery.map((img, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div className="relative aspect-[4/5] overflow-hidden">
              <img src={img} alt={`Remediation ${i + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-[800ms]" />
            </div>
          </Reveal>
        ))}
      </section>

      <section className="bg-charcoal text-white py-24 md:py-32" data-testid="service-enquire">
        <div className="container-x grid lg:grid-cols-2 gap-16">
          <div>
            <Overline light className="mb-6">Enquire Now</Overline>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold leading-tight mb-8">Have a structural or damp concern?</h2>
            <p className="text-white/70 font-light leading-relaxed max-w-md mb-8">We'll assess, diagnose and quote a permanent remediation solution — obligation free.</p>
            <a href={CONTACT.phoneHref} className="font-display text-3xl font-bold hover:text-sand transition-colors">{CONTACT.phone}</a>
          </div>
          <div className="bg-white p-8 md:p-10">
            <EnquiryForm defaultService="Concrete Repairs" />
          </div>
        </div>
      </section>
    </div>
  );
}
